import { FC } from "react";
import styles from "./styles.module.scss";
import { IProps } from "./types";
import clsx from "clsx";

const DayItem: FC<IProps> = ({
  date,
  isCompleted,
  isSelected,
  onSelect,
  isDisabled,
  indicatorColor,
}): JSX.Element => {
  return (
    <div
      onClick={isDisabled ? () => {} : onSelect}
      className={clsx(styles.wrapper, {
        [styles.wrapperSelected]: isSelected,
        [styles.wrapperDisabled]: isDisabled,
      })}
    >
      <span
        className={clsx(styles.dayTitle, {
          [styles.dayTitleSelected]: isSelected,
        })}
      >
        {date.format("ddd")}
      </span>
      <div
        className={clsx(styles.dayNumberWrapper, {
          [styles.dayNumberWrapperSelected]: isSelected,
        })}
      >
        <span
          className={clsx(styles.dayNumber, {
            [styles.dayNumberSelected]: isSelected,
          })}
        >
          {date.format("DD")}
        </span>
      </div>
      {isCompleted && (
        <div
          style={{ backgroundColor: indicatorColor }}
          className={styles.completedIndicator}
        />
      )}
    </div>
  );
};

export default DayItem;
